
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"18","viewBox":"0 0 11 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0.92813 2.48051L7.0841 9.00001L0.928276 15.5195C0.359343 16.085 0.357162 17.0041 0.923407 17.5724C1.48972 18.1407 2.41002 18.1427 2.97888 17.5773L10.5745 10.0275C11.1436 9.46009 11.1405 8.53665 10.573 7.9711L2.97873 0.422705C2.4098 -0.142771 1.48951 -0.140667 0.923262 0.42764C0.357018 0.995874 0.359198 1.91496 0.92813 2.48051Z","fill":"#C9D1D3"}})])
          )
        }
      }
    